module.exports = __webpack_public_path__ + "static/media/roby.4e7b5155.jpg";